export interface Product {
  id: string;
  name: string;
  category: string;
  series: string;
  price: string;
  image: string;
  detailImages?: string[];
  videoUrl?: string;
  thumbnail?: string;
  description: string;
  specs: {
    length: string;
    weight: string;
    material: string;
    buoyancy: string;
  };
  features: string[];
  scenarios: string[];
}

export const productCategories = [
  { id: 'all', name: '全部产品' },
  { id: 'gh2', name: 'GH二代系列' },
  { id: 'gl', name: '攻鲢手系列' },
  { id: 'lb', name: 'LB系列' },
  { id: 'nano', name: '纳米系列' },
  { id: 'reed', name: '芦苇系列' },
  { id: 'video', name: '安装视频' },
  { id: 'glsxmd', name: '双色醒目豆'}
];

export const products: Product[] = [
  // GH二代系列（纳米-日夜两用）
  {
    id: 'gh2-001',
    name: 'GH二代·日夜两用',
    category: 'gh2',
    series: 'GH二代系列',
    price: '¥45-59.9元/支',
    image: '/images/products/gh2/gh2-z1.jpg?v=1',
    detailImages: ['/images/products/gh2/gh2-01.png?v=2','/images/products/gh2/gh2-02.png?v=2'],
    description: '野钓黑坑鲫鲤设计的一款浮漂，双面OLED光源，0.7mm倒锥细尾',
    specs: {
      length: '28-52cm',
      weight: '1.2-3.2g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['双面OLED光源', '0.7mm倒锥细尾', '日夜两用'],
    scenarios: ['野钓', '黑坑鲫鲤', '浅水钓', '深水钓']
  },
  {
  id: 'gh2-002',
    name: 'GH二代·防眩一点提醒',
    category: 'gh2',
    series: 'GH二代系列',
    price: '¥58-69元/支',
    image: '/images/products/gh2/fx/fx-z1.jpg?v=1',
    detailImages: ['/images/products/gh2/fx/fx-1.jpg?v=1','/images/products/gh2/fx/fx-2.jpg?v=1'],
    description: '灯带柔光防眩涂层，双重防眩目更护眼，升级线状OLED灯带，0.55mm倒锥细尾',
    specs: {
      length: '28-52cm',
      weight: '1.2-3.2g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['双面OLED光源', '0.7mm倒锥细尾', '日夜两用'],
    scenarios: ['野钓', '黑坑鲫鲤', '浅水钓', '深水钓']
  },
  {
  id: 'gh2-003',
    name: 'GH二代·一点红提醒',
    category: 'gh2',
    series: 'GH二代系列',
    price: '¥59元/支',
    image: '/images/products/gh2/yd/yd-z1.jpg?v=1',
    detailImages: ['/images/products/gh2/yd/yd-1.jpg?v=1','/images/products/gh2/yd/yd-2.jpg?v=1','/images/products/gh2/yd/yd-3.jpg?v=1'],
    description: '单点变红做为提醒，不影响看鱼口信号全程灯光稳定不变、不暗、不切换，0.7mm倒锥细尾',
    specs: {
      length: '28-52cm',
      weight: '1.2-3.2g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['双面OLED光源', '0.7mm倒锥细尾', '日夜两用'],
    scenarios: ['野钓', '黑坑鲫鲤', '浅水钓', '深水钓']
  },

  // 攻鲢手系列
  {
    id: 'gl-001',
    name: '攻鲢手·白天漂',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥39元/支',
    image: '/images/products/gls/gls-b-z.jpg',
	detailImages: ['/images/products/gls/gls-bai1.png', '/images/products/gls/gls-bai2.png', '/images/products/gls/gls-bai3.png', '/images/products/gls/gls-bai4.png'],
    description: '黑坑鲢鳙设计的一款浮漂，特别对回锅鱼开发，专门解决回锅鱼警惕性高、出口轻难中鱼的问题。',
    specs: {
      length: '35-45cm',
      weight: '2.0-4.0g',
      material: '纳米材质',
      buoyancy: '高浮力'
    },
    features: ['回锅鱼专用', '空心玻纤材质', '轻浮力大', '信号清晰'],
    scenarios: ['黑坑鲢鳙', '回锅鱼', '白天钓']
  },
  {
    id: 'gl-002',
    name: '攻鲢手·LED灯排尾',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥55-69元/支',
    image: '/images/products/gls/gls-led-z.jpg',
	detailImages: ['/images/products/gls/gls-led1.png', '/images/products/gls/gls-led2.png', '/images/products/gls/gls-led3.png'],
    description: '黑坑鲢鳙设计的LED灯排尾浮漂，升级发光方式，改用LED双排灯带。',
    specs: {
      length: '36.4-62cm',
      weight: '3.5-7g',
      material: '纳米材质',
      buoyancy: '高浮力'
    },
    features: ['LED双排灯带', '浅水专用'],
    scenarios: ['浅水鲢鳙', '水皮钓', '夜钓']
  },
   {
    id: 'gl-003',
    name: '攻鲢手·回锅款·非LED尾',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥59元/支',
    image: '/images/products/gls/gls-hg-z.jpg?v=1',
	detailImages: ['/images/products/gls/gls-huiguo.jpg?v=1'],
    description: '采用灯珠+光纤柔目发光技术，全目3.1mm加粗，载饵能力强。',
    specs: {
      length: '64-76cm',
      weight: '6.0-8.0g',
      material: '纳米材质',
      buoyancy: '高浮力'
    },
    features: ['柔目发光', '数控芯片', '3.0mm加粗', 'CR425电池'],
    scenarios: ['回锅鲢鳙', '黑坑', '夜钓']
  },
 /* {
    id: 'gl-004',
    name: '攻鲢手·定层款·非LED尾',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥59元/支',
    image: '/images/products/gls/gls-dc-z.jpg?v=1',
	detailImages: ['/images/products/gls/gls-dc-1.jpg'],
    description: '采用灯珠+光纤柔目发光技术，中间三目加粗3.6mm，尾径2.4-3.6-2.4mm',
    specs: {
      length: '60-65cm',
      weight: '3.5-7.0g',
      material: '纳米材质',
      buoyancy: '超高灵敏'
    },
    features: ['柔目发光', '数控芯片', '3.6mm加粗', 'CR425电池'],
    scenarios: ['回锅鲢鳙', '黑坑', '夜钓']
  }, */
  {
    id: 'gl-005',
    name: '攻鲢手·回锅款·白天漂',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥45元/支',
    image: '/images/products/gls/gls-b-z.jpg',
	detailImages: ['/images/products/gls/gls-hg-b-1.jpg'],
    description: '中空尾全目3.1mm加粗，载饵能力强。',
    specs: {
      length: '60-65cm',
      weight: '3.5-7.0g',
      material: '纳米材质',
      buoyancy: '超高灵敏'
    },
    features: ['3.1mm加粗','空心玻纤材质', '轻浮力大', '信号清晰'],
    scenarios: ['回锅鲢鳙', '黑坑', '夜钓']
  },
   {
    id: 'gl-006',
    name: '攻鲢手·抗走水·非LED尾',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥69元/支',
    image: '/images/products/gls/gls-kong-1.jpg',
	detailImages: ['/images/products/gls/gls-kong-2.jpg','/images/products/gls/gls-kong-3.jpg','/images/products/gls/gls-kong-4.jpg?v=2','/images/products/gls/kzs7080.jpg','/images/products/gls/gls-kong-5.jpg'],
    description: '专为黑坑·无限回锅鲢鳙&抗走水,一漂双尾/全目加粗,3.1mm+4.5mm',
    specs: {
      length: '80-85cm',
      weight: '6.0-8.0g',
      material: '纳米材质',
      buoyancy: '超高灵敏'
    },
    features: ['4.5mm加粗','空心玻纤材质', '轻浮力大', '信号清晰'],
    scenarios: ['回锅鲢鳙', '黑坑', '夜钓']
  },
     {
    id: 'gl-007',
    name: '攻鲢手·抗走水加长款·非LED尾',
    category: 'gl',
    series: '攻鲢手系列',
    price: '¥65元/支',
    image: '/images/products/gls/kzs/kzs.jpg',
	detailImages: ['/images/products/gls/kzs/kzsjc.jpg'],
    description: '专为黑坑·无限回锅鲢鳙&抗走水加长款,3.1mm全目加粗',
    specs: {
      length: '89.5cm',
      weight: '6.0-8.0g',
      material: '纳米材质',
      buoyancy: '超高灵敏'
    },
    features: ['3.1mm加粗','空心玻纤材质', '轻浮力大', '信号清晰'],
    scenarios: ['回锅鲢鳙', '黑坑', '夜钓']
  },
  // LB系列（芦苇-白天漂）
  {
    id: 'lb-001',
    name: 'LB系列·白天漂',
    category: 'lb',
    series: 'LB系列',
    price: '¥39元/支',
    image: '/images/products/lb/lb-z.jpg',
	detailImages: ['/images/products/lb/01.png', '/images/products/lb/02.png', '/images/products/lb/03.png', '/images/products/lb/04.png', '/images/products/lb/05.png', '/images/products/lb/06.png', '/images/products/lb/07.png', '/images/products/lb/08.png'],
    description: '野钓大综合设计的一款浮漂，包含野钓中常见鱼种，高透硬尾更透亮，特殊工艺烘干，自重更轻。',
    specs: {
      length: '32-42cm',
      weight: '1.5-2.5g',
      material: '陈年芦苇',
      buoyancy: '高灵敏'
    },
    features: ['高透硬尾', '特殊烘干工艺', '高倍比吃铅', '爆顶加固'],
    scenarios: ['野钓大综合', '多种鱼种', '白天钓']
  },
    {
    id: 'lb-002',
    name: 'LB系列·哪吒·直击天命',
    category: 'lb',
    series: 'LB系列',
    price: '¥42.8元/支',
    image: '/images/products/lb/zjtm-z.jpg',
	detailImages: ['/images/products/lb/zjtm.jpg?v=1'],
    description: '大混养黑坑鲫鲤抢鱼浮漂，翻身速度较快，有带一些行程，灵敏度高，漂尾醒目',
    specs: {
      length: '42-46cm',
      weight: '1.5-2.3g',
      material: '陈年芦苇',
      buoyancy: '高灵敏'
    },
    features: ['哪吒主题', '高透硬尾', '特殊工艺', '个性外观'],
    scenarios: ['野钓', '收藏', '白天钓']
  },
   {
    id: 'lb-003',
    name: 'LB系列·哪吒',
    category: 'lb',
    series: 'LB系列',
    price: '¥42.8元/支',
    image: '/images/products/lb/nez-z.jpg',
	detailImages: ['/images/products/lb/lbe-ez01.jpg'],
    description: '哪吒主题限量款浮漂，采用高透硬尾设计，特殊工艺处理，外观独特个性。',
    specs: {
      length: '45-46cm',
      weight: '1.5-2.3g',
      material: '陈年芦苇',
      buoyancy: '高灵敏'
    },
    features: ['哪吒主题', '高透硬尾', '特殊工艺', '个性外观'],
    scenarios: ['野钓', '收藏', '白天钓']
  },

  // 纳米系列
  {
    id: 'nano-001',
    name: '一心·纳米·白天漂',
    category: 'nano',
    series: '纳米系列',
    price: '¥90元/支',
    image: '/images/products/yxnm/yxnm-z.jpg',
	detailImages: ['/images/products/yxnm/yxnm01.png?v=1','/images/products/yxnm/yxnm02.png?v=1','/images/products/yxnm/yxnm03.png?v=1','/images/products/yxnm/yxnm04.png?v=1','/images/products/yxnm/yxnm05.png?v=1','/images/products/yxnm/yxnm06.png?v=1','/images/products/yxnm/yxnm07.png?v=1','/images/products/yxnm/yxnm08.png?v=1','/images/products/yxnm/yxnm09.png?v=1'],
    description: '高吃铅比，漂脚漂尾锥细，减轻自重、灵敏度提升，软身漆防爆顶，吃铅准、误差小。',
    specs: {
      length: '30-45cm',
      weight: '1.0-2.5g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['八道质检', '误差0.02g以内', '3.4倍吃铅比', '软身漆防爆'],
    scenarios: ['竞技钓', '黑坑', '白天钓']
  },
  {
    id: 'nano-002',
    name: '壹号漂·综合款',
    category: 'nano',
    series: '纳米系列',
    price: '¥25元/支',
    image: '/images/products/1hao/1hao-z.jpg',
	detailImages: ['/images/products/1hao/01.png','/images/products/1hao/02.png','/images/products/1hao/03.png','/images/products/1hao/04.png','/images/products/1hao/01x.png','/images/products/1hao/02x.png'],
    description: '不同漂型漂尾细节单独设计，保证不同杆长醒目又灵敏，漂身标注吃铅、建议鱼种、建议杆长。',
    specs: {
      length: '28-42cm',
      weight: '0.8-2.5g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['漂尾单独设计', '标注详细', '一体通纤', '防止爆顶'],
    scenarios: ['新手钓', '综合钓', '白天钓']
  },
    {
    id: 'nano-004',
    name: 'CD系列·白天漂',
    category: 'nano',
    series: '纳米系列',
    price: '¥29-35元/支',
    image: '/images/products/cd/cd-z.jpg',
	detailImages: ['/images/products/cd/cd01.png','/images/products/cd/cd02.png','/images/products/cd/cd03.png'],
    description: 'CD系列纳米白天漂，炮杆定点钓研发，适合多种垂钓场景。',
    specs: {
      length: '32-40cm',
      weight: '1.0-2.0g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['专业设计', '性价比高', '多场景适用', '品质保证'],
    scenarios: ['休闲钓', '黑坑', '白天钓']
  },
   {
    id: 'nano-006',
    name: '攻滑鲢·LED灯排尾',
    category: 'nano',
    series: '纳米系列',
    price: '¥98元/支',
    image: '/images/products/ghl/ghl-z.jpg',
	detailImages: ['/images/products/ghl/ghl01.png','/images/products/ghl/ghl02.png'],
    description: '漂尾加粗采用1.3-1.9mm顶部加粗和1.3-1.9-1.3mm中部加粗方式，小尾径加自重轻出口会更好，同时对于用户自身控饵的能力会较高；',
    specs: {
      length: '35-45cm',
      weight: '1.2-2.5g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['精细工艺', '性能稳定'],
    scenarios: ['黑坑', '竞技钓']
  },
 {
    id: 'nano-007',
    name: 'HK三代-青云直上·LED灯排尾',
    category: 'nano',
    series: '纳米系列',
    price: '¥69-79元/支',
    image: '/images/products/hk3/hk3-z.jpg',
	detailImages: ['/images/products/hk3/hk3.png'],
    description: '倒锥细尾，切水快，翻身迅速，腰力更强，不易断尾，顿口明显；',
    specs: {
      length: '60cm',
      weight: '1.5-3.1g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['精细工艺', '性能稳定'],
    scenarios: ['黑坑', '竞技钓']
  },
   {
    id: 'nano-008',
    name: '慢诱·LED灯排尾',
    category: 'nano',
    series: '纳米系列',
    price: '¥49-90元/支',
    image: '/images/products/my/my-z.jpg',
	detailImages: ['/images/products/my/my-01.jpg?v=1','/images/products/my/my-02.jpg?v=1','/images/products/my/my-03.jpg?v=1','/images/products/my/my-04.jpg?v=1','/images/products/my/my-05.jpg?v=1','/images/products/my/my-06.jpg?v=1','/images/products/my/my-09.jpg?v=1','/images/products/my/my-new.jpg?v=2' ],
    description: '夜光尾采用LED双排灯珠尾，白天款采用扁尾设计,日夜两用双尾无缝替换；',
    specs: {
      length: '80cm',
      weight: '5.0-12g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['精细工艺', '性能稳定'],
    scenarios: ['黑坑', '竞技钓']
  },
     {
    id: 'nano-009',
    name: 'JT双浮·白天漂',
    category: 'nano',
    series: '纳米系列',
    price: '¥35元/支',
    image: '/images/products/jt/jt-z.jpg',
	detailImages: ['/images/products/jt/jt01.jpg?v=1'],
    description: '【双浮】鲢鱅浮漂，漂尾颜色醒目，飘相信号准确，托饵时容错空间；',
    specs: {
      length: '36-61cm',
      weight: '4.0-8.5g',
      material: '纳米材质',
      buoyancy: '高灵敏'
    },
    features: ['精细工艺', '性能稳定'],
    scenarios: ['黑坑', '竞技钓']
  },
  
  // 芦苇系列（白天漂）
  {
    id: 'reed-001',
    name: '一心·芦苇·白天漂',
    category: 'reed',
    series: '芦苇系列',
    price: '¥100元/支',
    image: '/images/products/yxlw/yxlw-z.jpg',
	detailImages: ['/images/products/yxlw/yxlw01.png','/images/products/yxlw/yxlw02.png','/images/products/yxlw/yxlw03.png'],
    description: '定制荧光漆透光性强长时间不掉漆，一体通纤防爆顶加固，S级陈年芦苇纯手工打磨。',
    specs: {
      length: '32-45cm',
      weight: '1.2-2.8g',
      material: '陈年芦苇',
      buoyancy: '超高灵敏'
    },
    features: ['定制荧光漆', '一体通纤', 'S级芦苇', '手工打磨'],
    scenarios: ['黑坑', '竞技钓', '白天钓']
  },
    {
    id: 'reed-002',
    name: 'LS芦苇·白天漂',
    category: 'reed',
    series: '芦苇系列',
    price: '¥98元/支',
    image: '/images/products/ls/ls-z.jpg',
	detailImages: ['/images/products/ls/ls01.png'],
    description: '一款非常经典的芦苇漂型，号数1-7号，吃铅0.8-2.6克可供选择，这是一款综合漂，适合目前国内大部分水域和鱼情。',
    specs: {
      length: '30-40cm',
      weight: '1.0-2.0g',
      material: '陈年芦苇',
      buoyancy: '高灵敏'
    },
    features: ['1.5倍吃铅比', '自重轻', '八道质检', '四遍上漆'],
    scenarios: ['轻口鱼', '竞技钓', '白天钓']
  },
  {
    id: 'reed-003',
    name: '攻鲫·芦苇·白天漂',
    category: 'reed',
    series: '芦苇系列',
    price: '¥130元/支',
    image: '/images/products/gj/gj-z.jpg?v=2',
	detailImages: ['/images/products/gj/gj-01.jpg?v=1','/images/products/gj/gj-02.jpg?v=1','/images/products/gj/gj-03.jpg?v=1','/images/products/gj/gj01.jpg?v=1'],
    description: '高吃铅倍比，自重轻易抛投。特研荧光油墨尾漆，透光性更强，防止老化。',
    specs: {
      length: '28-38cm',
      weight: '0.8-1.8g',
      material: '陈年芦苇',
      buoyancy: '超高灵敏'
    },
    features: ['误差0.1g以内', '专供油墨', '超1.5倍吃铅', '信号稳定'],
    scenarios: ['鲫鱼钓', '轻口鱼', '白天钓']
  },
  
   // 双色醒目豆
    {
    id: 'glsxmd-001',
    name: '双色胶囊醒目豆',
    category: 'glsxmd',
    series: '双色胶囊醒目豆',
    price: '¥9.9-19.9元',
    image: '/images/smd/smd.jpg',
	detailImages: ['/images/smd/smd01.jpg?v=1','/images/smd/smd02.jpg?v=1','/images/smd/smd04.jpg?v=2'],
    description: '双色醒目定层豆,无需打胶水可自由拆卸,专属孔径/不易脱落,多种孔径可选',
    specs: {
      length: 'N/A',
      weight: 'N/A',
      material: '双色醒目豆',
      buoyancy: 'N/A'
    },
    features: ['双色醒目豆', '安装技巧', '演示', '实用教程'],
    scenarios: ['双色醒目豆', '安装', '拆缷']
  },

  // 安装视频
  {
    id: 'video-001',
    name: '单扣展板安装视频',
    category: 'video',
    series: '展板安装视频',
    price: '',
    image: '/images/zb.jpg',
    videoUrl: '/videos/dk.mp4',
    thumbnail: '/images/videos/zb.jpg',
    description: '单扣展板详细安装教程，包含展板组装、固定、调试等完整步骤，帮助经销商快速完成展板安装。',
    specs: {
      length: 'N/A',
      weight: 'N/A',
      material: '视频教程',
      buoyancy: 'N/A'
    },
    features: ['详细安装步骤', '高清视频演示', '专业讲解', '快速上手'],
    scenarios: ['经销商', '展板安装', '培训教程']
  },
  {
    id: 'video-002',
    name: '双扣展板安装视频',
    category: 'video',
    series: '展板安装视频',
    price: '',
    image: '/images/zb.jpg',
    videoUrl: '/videos/sk.mp4',
    thumbnail: '/images/videos/zb.jpg',
    description: '双扣展板详细安装教程，展示双扣结构的组装方法、固定技巧和调试要点，适合各类门店使用。',
    specs: {
      length: 'N/A',
      weight: 'N/A',
      material: '视频教程',
      buoyancy: 'N/A'
    },
    features: ['双扣结构详解', '安装技巧', '高清演示', '实用教程'],
    scenarios: ['经销商', '展板安装', '门店布置']
  },
  {
    id: 'video-003',
    name: '醒目豆安装视频',
    category: 'video',
    series: '醒目豆安装视频',
    price: '',
    image: '/images/smd/smd.jpg',
    videoUrl: '/videos/smd.mp4',
    thumbnail: '/images/smd/smd.jpg',
    description: '双色醒目豆详细安装拆缷操作教程，展示醒目豆的组装方法、固定技巧和调试要点。',
    specs: {
      length: 'N/A',
      weight: 'N/A',
      material: '视频教程',
      buoyancy: 'N/A'
    },
    features: ['双色醒目豆', '安装技巧', '演示', '实用教程'],
    scenarios: ['双色醒目豆', '安装', '拆缷']
  }
];
